<onyx-section [heading]="`${I18N}.heading`">
  @let controls = form().controls;
  <form [formGroup]="form()">
    <div class="form-inputs">
      <onyx-form-group [controls]="controls.termDays">
        <onyx-text-field
          [formControl]="controls.termDays"
          label="labels.paymentTerm"
          [decimalPlaces]="0"
          unit="labels.days"
          [showErrors]="false"
          [size]="32"
        ></onyx-text-field>

        <onyx-suggestions
          [control]="controls.termDays"
          [suggestions]="TERM_DAYS_SUGGESTIONS"
        ></onyx-suggestions>
      </onyx-form-group>

      <onyx-form-group [controls]="controls.termType" label="labels.termFrom">
        <onyx-dropdown
          [formControl]="controls.termType"
          [hint]="`${I18N}.termTypeHint`"
          [options]="termTypes$ | async"
          [showErrors]="false"
          [size]="32"
        ></onyx-dropdown>

        <onyx-suggestions
          [control]="controls.termType"
          [suggestions]="TERM_TYPES_SUGGESTIONS"
        ></onyx-suggestions>
      </onyx-form-group>

      @if (controls.selectedTermDay.enabled) {
        <onyx-text-field
          [formControl]="controls.selectedTermDay"
          label="labels.dayOfMonth"
          [decimalPlaces]="0"
          [size]="32"
        ></onyx-text-field>
      }
    </div>

    <div class="parameters">
      <p class="f-body-xs f-medium">{{ 'labels.parameters' | translate }}</p>

      @let parametersGroup = controls.parameters;
      @let parametersControls = parametersGroup.controls;
      <div class="container" [formGroup]="parametersGroup">
        <div class="item">
          <onyx-toggle
            label="labels.tradeCredit"
            [(checked)]="hasTradeCreditLimit"
          ></onyx-toggle>

          @let tradeCreditLimitGroup = parametersControls.tradeCreditLimit;
          @let tradeCreditLimitControls = tradeCreditLimitGroup.controls;
          @if (hasTradeCreditLimit()) {
            <onyx-form-group
              [formGroup]="tradeCreditLimitGroup"
              [controls]="[
                tradeCreditLimitControls.value,
                tradeCreditLimitControls.currency,
              ]"
              [gap]="8"
            >
              <onyx-text-field
                [formControl]="tradeCreditLimitControls.value"
                placeholder="labels.limit"
                [decimalPlaces]="0"
                [size]="32"
                width="100px"
                [showErrors]="false"
              ></onyx-text-field>

              <onyx-dropdown
                [formControl]="tradeCreditLimitControls.currency"
                [options]="currencies$ | async"
                [size]="32"
                width="80px"
              ></onyx-dropdown>
            </onyx-form-group>
          }
        </div>

        <div class="item">
          <onyx-toggle
            class="cash-discount"
            label="labels.cashDiscount"
            [(checked)]="hasCashDiscount"
          ></onyx-toggle>

          @let cashDiscountControls = parametersControls.cashDiscount.controls;
          @if (hasCashDiscount()) {
            <div class="discounts">
              @for (group of cashDiscountControls; track group) {
                <div class="discount">
                  <onyx-text-field
                    [formControl]="group.controls.percentage"
                    placeholder="labels.cashDiscount"
                    [decimalPlaces]="2"
                    unit="%"
                    [size]="32"
                    width="95px"
                  ></onyx-text-field>

                  <onyx-text-field
                    [formControl]="group.controls.termDays"
                    placeholder="labels.term"
                    [decimalPlaces]="0"
                    unit="labels.days"
                    [size]="32"
                    width="95px"
                  ></onyx-text-field>

                  <onyx-icon-button
                    variant="transparent"
                    color="gray"
                    [size]="32"
                    icon="delete-outlined"
                    (click)="removeDiscount($index)"
                  ></onyx-icon-button>

                  @if ($last) {
                    <div class="separator"></div>

                    <onyx-button
                      variant="outlined"
                      [size]="32"
                      (click)="addDiscount()"
                    >
                      {{ 'labels.add' | translate }}
                    </onyx-button>
                  }
                </div>
              }
            </div>
          }
        </div>

        <div class="item">
          <onyx-toggle
            [formControl]="parametersControls.hasFactoringConsent"
            label="labels.factoringConsent"
          ></onyx-toggle>
        </div>
      </div>
    </div>
  </form>
</onyx-section>
